export default __webpack_public_path__ + "static/media/EmptyFilterResults.6fc02cb1.svg";